'use strict';

var Json_decode = require("@glennsl/bs-json/lib/js/src/Json_decode.js");
var Url$PvpcontrollerWeb = require("./Url.js");
var Request$PvpcontrollerWeb = require("./Request.js");
var UpdateResponse$PvpcontrollerWeb = require("./UpdateResponse.js");
var ArmorPieceModel$PvpcontrollerWeb = require("../models/ArmorPieceModel.js");
var EditModeService$PvpcontrollerWeb = require("./EditModeService.js");

function armorPiecesResponse(json) {
  return {
          status: Json_decode.field("status", Json_decode.$$int, json),
          armorPieces: Json_decode.field("armorPieces", (function (param) {
                  return Json_decode.array(ArmorPieceModel$PvpcontrollerWeb.Decode.armorPiece, param);
                }), json)
        };
}

function armorPieceResponse(json) {
  return {
          status: Json_decode.field("status", Json_decode.$$int, json),
          armorPiece: Json_decode.field("armorPiece", ArmorPieceModel$PvpcontrollerWeb.Decode.armorPiece, json)
        };
}

function armorPieceSearchResponse(json) {
  return {
          status: Json_decode.field("status", Json_decode.$$int, json),
          armorPieces: Json_decode.field("armorPieces", (function (param) {
                  return Json_decode.array(ArmorPieceModel$PvpcontrollerWeb.Decode.armorPiece, param);
                }), json)
        };
}

function armorPieceChangelogResponse(json) {
  return {
          status: Json_decode.field("status", Json_decode.$$int, json),
          changes: Json_decode.field("changes", (function (param) {
                  return Json_decode.array(EditModeService$PvpcontrollerWeb.Decode.change, param);
                }), json),
          totalSize: Json_decode.field("totalSize", Json_decode.$$int, json)
        };
}

function getArmorPiece(id, cb) {
  return Request$PvpcontrollerWeb.getWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/armorPiece/" + String(id), (function (response) {
                return {
                        TAG: /* Ok */0,
                        _0: armorPieceResponse(response).armorPiece
                      };
              }), cb);
}

function getArmorPieces(offset, amt, cb) {
  return Request$PvpcontrollerWeb.getWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/armorPieces/all/" + String(offset) + "/" + String(amt), (function (response) {
                return {
                        TAG: /* Ok */0,
                        _0: armorPiecesResponse(response).armorPieces
                      };
              }), cb);
}

function getArmorPieceChangelog(id, skip, limit, cb) {
  var skip$1 = String(skip);
  var limit$1 = String(limit);
  return Request$PvpcontrollerWeb.getWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/armorPiece/changelog/" + id.toString() + "/" + skip$1 + "/" + limit$1, (function (response) {
                var match = armorPieceChangelogResponse(response);
                return {
                        TAG: /* Ok */0,
                        _0: {
                          changes: match.changes,
                          totalSize: match.totalSize
                        }
                      };
              }), cb);
}

function searchArmorPieces(terms, cb) {
  var terms$1 = encodeURIComponent(terms);
  return Request$PvpcontrollerWeb.getWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/armorPieces/search/" + terms$1, (function (response) {
                return {
                        TAG: /* Ok */0,
                        _0: armorPieceSearchResponse(response).armorPieces
                      };
              }), cb);
}

function updateArmorPieceDefense(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var netId = String(param$1.netId);
  var defense = String(param$1.currentDefense);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/armorPiece/update/defense", "defense=" + defense + "&netID=" + netId + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateArmorPieceMeleeDamagePercentage(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var netId = String(param$1.netId);
  var meleeDamagePercentage = String(param$1.currentMeleeDamagePercentage);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/armorPiece/update/meleeDamagePercentage", "meleeDamagePercentage=" + meleeDamagePercentage + "&netID=" + netId + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateArmorPieceMagicDamagePercentage(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var netId = String(param$1.netId);
  var magicDamagePercentage = String(param$1.currentMagicDamagePercentage);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/armorPiece/update/magicDamagePercentage", "magicDamagePercentage=" + magicDamagePercentage + "&netID=" + netId + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateArmorPieceRangedDamagePercentage(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var netId = String(param$1.netId);
  var rangedDamagePercentage = String(param$1.currentRangedDamagePercentage);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/armorPiece/update/rangedDamagePercentage", "rangedDamagePercentage=" + rangedDamagePercentage + "&netID=" + netId + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateArmorPieceMinionDamagePercentage(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var netId = String(param$1.netId);
  var minionDamagePercentage = String(param$1.currentMinionDamagePercentage);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/armorPiece/update/minionDamagePercentage", "minionDamagePercentage=" + minionDamagePercentage + "&netID=" + netId + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

exports.getArmorPiece = getArmorPiece;
exports.getArmorPieces = getArmorPieces;
exports.getArmorPieceChangelog = getArmorPieceChangelog;
exports.searchArmorPieces = searchArmorPieces;
exports.updateArmorPieceDefense = updateArmorPieceDefense;
exports.updateArmorPieceMeleeDamagePercentage = updateArmorPieceMeleeDamagePercentage;
exports.updateArmorPieceMagicDamagePercentage = updateArmorPieceMagicDamagePercentage;
exports.updateArmorPieceRangedDamagePercentage = updateArmorPieceRangedDamagePercentage;
exports.updateArmorPieceMinionDamagePercentage = updateArmorPieceMinionDamagePercentage;
/* Url-PvpcontrollerWeb Not a pure module */
